import React from 'react'
import { Container as MContainer, ContainerProps as MContainerProps } from '@material-ui/core'

export type ContainerProps = MContainerProps

export default function Container ({ maxWidth, ...props }: ContainerProps) {
  return (
    <MContainer
      {...props}
      maxWidth={maxWidth || 'lg'}
    />
  )
}
